import type { ApiSitterFaqMessage } from '@app/packages/internalApi/types'
import { createInternalApiAction } from '@app/packages/internalApi/utils'

export const getSitterFaqMessages = () =>
  createInternalApiAction('getSitterFaqMessages', dispatch =>
    dispatch<{ data: ApiSitterFaqMessage[] }>({
      method: 'GET',
      endpoint: '/internal/api/v1/sitter_faq_messages',
    })
  )
